import { css } from 'styled-system/css';

export const defaultStakeStyle = {
	root: css({
		_mars: {
			px: '9px',
		}
	}),
	item: css({
		base: {
			color: 'var(--body-text)',
			'--row-border': { base: 'var(--lv1-8)', _dark: 'rgba(0, 0, 0, 0.12)' },
			borderBottom: '1px solid var(--row-border)',
		},
		_mars: {
			borderTopWidth: '1px',
			borderStyle: 'solid',
			borderColor: 'black.5',
			color: 'black.1',
			_first: {
				borderTopWidth: 0,
			},
			_last: {
				borderBottomWidth: 0,
			},
			'&[data-active="true"]': {
				color: 'brand.500'
			}
		},
	}),
	row: css({
		base: {
			display: 'flex',
			justifyContent: 'flex-start',
			alignItems: 'center',
			cursor: 'pointer',
			minH: '36px',
			gap: '12px',
			padding: '12px'
		},
		_mars: {
			minH: '49px',
			gap: '6px',
			px: '9px',
			py: '12px',
		},
	}),
	rowRadio: css({
		base: {
			flex: '0 0 auto',
			color: 'var(--lv1-50)',
			'& .icon--radio-on': {
				display: 'block',
				color: 'var(--p500)',
			},
		},
		_mars: {
			display: 'none',
		}
	}),
	content: css({
		base: {
			p: '9px'
		},
		_mars: {
			py: '12px',
			borderTopWidth: '1px',
			borderStyle: 'solid',
			borderColor: 'black.5',
			'& .stake-input': {
				bgColor: 'white.1',
				borderWidth: '1px',
				borderStyle: 'solid',
				borderColor: 'black.5',
			},
			'& .keypad': {
				mt: '12px',
				borderWidth: '1px',
				borderStyle: 'solid',
				borderColor: 'black.5',
			},
		},
	}),

	rowControl: css({
		base: {
			display: 'none',
		},
		_mars: {
			display: 'block',
			ml: 'auto'
		},
	}),
};